import { Controller, useFormContext } from 'react-hook-form';

import { Dropdown } from '@ui/components/Dropdown';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const OPTIONS = [
  { value: false, label: 'Отключена' },
  {
    value: true,
    label: 'Конвертировать в круговую или матч',
  },
];

export function SwissSystemChangeInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel hint="при нехватке игроков">Смена системы</FormLabel>

      <FormInput>
        <Controller
          name="automatedSystemChangeEnabled"
          control={control}
          defaultValue={true}
          render={({ field: { value, onChange, disabled } }) => {
            const onValidChange = (value: string) => {
              onChange(value === 'true');
            };
            return (
              <Dropdown
                options={OPTIONS}
                value={value ? 'true' : 'false'}
                onChange={onValidChange}
                disabled={disabled}
              />
            );
          }}
        />
      </FormInput>
    </FormRow>
  );
}
